export default __webpack_public_path__ + "static/media/fbcolor.b6fc6374.svg";